module.exports = __webpack_public_path__ + "img/home_creative-image.7979d077.jpg";